import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router'
import { App } from './app'
import './globals.css'

const incomingSignupKey = new URLSearchParams(window.location.search).get('key')
if (incomingSignupKey) {
  localStorage.setItem('etx_signup_key', incomingSignupKey)
}

createRoot(document.getElementById('root')!).render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
)
